// Public "how to delete your account" guide — route
// /#/content/view/content-howtodeleteaccount (frozen URL: this exact path is
// registered in the Google Play / App Store listings for the mobile app).
//
// Reproduced VERBATIM from the legacy frontend (store-compliance text). The original
// wording — including the "mt profile tab" typo — is preserved intentionally; changing
// store-referenced copy is out of scope for the rehosting.
import StaticPageLayout from './StaticPageLayout'
import { t } from '../../i18n'

const DeleteAccount = () => {
  return (
    <StaticPageLayout title={t.deleteAccountTitle} wide>
      <div className="cf-legal">
        <h2>How to delete your data and account on QR-Phone app?</h2>
        <p>
          This link provides information on how users can request the deletion of their QR-Phone
          account and outlines the specific steps to follow for a seamless process.
        </p>

        <h3>Steps to Delete Your Account:</h3>
        <p>
          <strong>1. Navigate to My Profile:</strong> After logging in, access the mt profile tab by
          either selecting it from the bottom tabs or clicking on the avatar icon located in the
          top-right corner of the QR-Phone mobile app.
        </p>
        <p>
          <strong>2. Locate "Delete Account" Button:</strong> On the Account screen, you will find a
          prominently displayed "Delete Account" button.
        </p>
        <p>
          <strong>3. Confirmation Prompt:</strong> Tapping the "Delete Account" button will prompt a
          confirmation dialogue. To proceed, type the word "delete" as confirmation.
        </p>

        <h3>Data Deletion Details:</h3>
        <p>Upon completing the account deletion process, the following data will be permanently erased:</p>
        <ul>
          <li>
            <strong>Personal Information:</strong> All personal information linked to your account will
            be deleted.
          </li>
          <li>
            <strong>Email Address:</strong> The email address collected during the signup process will
            also be permanently removed from our records.
          </li>
        </ul>

        <h3>Retention Period:</h3>
        <p>
          There is no additional retention period for the deleted data. Once the account deletion is
          confirmed, the information is promptly and permanently removed from our system.
        </p>
      </div>
    </StaticPageLayout>
  )
}

export default DeleteAccount
